import React from "react";
import autobind from "class-autobind";
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaPlusCircle, FaTrashAlt, FaCopy } from "react-icons/fa";
import {Tooltip} from "../../tooltip/index";

interface Props {
  values: DeliveryFeeRange[];
  onChange: (values: DeliveryFeeRange[]) => void;
}

export class FieldDeliveryFeeRange extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
    autobind(this);
  }

  add() {
    const values = [ ...this.props.values ];
    values.push({
      up_to: 0,
      cost: 0,
    });
    this.props.onChange(values);
  }

  copy(i: number) {
    const values = [ ...this.props.values ];
    const value = { ...values[i] };
    values.push(value);
    this.props.onChange(values);
  }

  remove(i: number) {
    const values = ([ ...this.props.values ]);
    values.splice(i, 1);
    this.props.onChange(values);
  }

  change(i: number, key: keyof DeliveryFeeRange, value: number | string) {
    const values = [ ...this.props.values ];
    values[i][key] = value as number;
    this.props.onChange(values);
  }

  render() {
    const { values } = this.props;
    return (
      <div>

        { values.length === 0 &&
          <Button size="xs" color="primary-inverse" type="button" onClick={this.add}>
            Create Price Bracket
          </Button>
        }

        { values.map((item, i) => {
          return (
            <div key={i} className="flex-line m-t-3" style={{ alignItems: "flex-end" }}>

              <InputBox className="no-round width32 text-center">
                <p className="big font-bold" style={{ lineHeight: "36px" }}>{i + 1}</p>
              </InputBox>

              <div className="flex-line" style={{ alignItems: "flex-end" }}>
                <FormGroup
                  className="m-b-0"
                  title={
                    i === 0 ?
                      `Between 0 to ${values[i].up_to || "X"} kilometers` :
                      `Between ${values[i - 1].up_to || "X"} to ${values[i].up_to || "X"} kilometers`
                  }
                  small_title={true}
                  no_border={true}>
                  <Input
                    placeholder="Up to X kilometers"
                    required={true}
                    type="number"
                    step={0.01}
                    className="no-round"
                    style={{ width: "220px" }}
                    value={item.up_to}
                    onChange={(e) => this.change(i, "up_to", parseFloat(e.target.value) || 0)}/>
                </FormGroup>

                <FormGroup
                  className="m-b-0"
                  title="Cost ($)"
                  small_title={true}
                  no_border={true}>
                  <Input
                    type="number"
                    required={true}
                    step={0.01}
                    className="no-round"
                    style={{ width: "150px" }}
                    value={item.cost}
                    onChange={(e) => this.change(i, "cost", parseFloat(e.target.value) || 0)}/>
                </FormGroup>

              </div>

              { (this.props.values.length - 1) === i &&
              <Tooltip text="Add" width={65} position="top">
                <Button type="button" className="no-round" paddinglr={5} color="white" onClick={this.add}>
                  <FaPlusCircle/>
                </Button>
              </Tooltip>
              }
              <Tooltip text="Delete" width={65} position="top">
                <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => this.remove(i)}>
                  <FaTrashAlt/>
                </Button>
              </Tooltip>
              <Tooltip text="Copy" width={65} position="top">
                <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => this.copy(i)}>
                  <FaCopy/>
                </Button>
              </Tooltip>

            </div>
          );
        })}

      </div>
    );
  }
}
